module.exports = Em.Handlebars.compile("{{#each option in view.options}}\n    {{view buttonViewClass optionBinding=\"option\"}}\n{{/each}}");